import Resource from './Resource';
import SocialMedia from './SocialMedia';

const Body = () => {
  return (
    <div
      className="pb-56 pt-96 sm:pt-120 mx-auto relative sm:px-96 md:px-0"
      style={{ maxWidth: 858 }}
    >
      <Resource />
      <SocialMedia />
    </div>
  );
};

export default Body;
